module.exports = __webpack_public_path__ + "assets/img/8650f3c6bd9c71d2cfba9ddafa3bae9a.png";